module.exports = __webpack_public_path__ + "img/qwei.bb09894e.png";